import type { ILogService } from "angular";

import type { StateService, TransitionService } from "@uirouter/angularjs";

import type { ILoginService, IProfileService } from "App/Modules/Auth";

import { get } from "lodash";
import { Permission } from "App/Modules/Models/Models/Permission";
import type { IModalService } from "App/Modules/Services/FormContainer/Modal/IModalService";
import type { IMmState } from "./Interfaces";

export default function appRun(
    $log: ILogService,
    $state: StateService,
    hotkeys: angular.hotkeys.HotkeysProvider,
    $http: any,
    $trace: any,
    $templateRequest: any,
    $transitions: TransitionService,
    loginService: ILoginService,
    profileService: IProfileService,
    modalService: IModalService,
) {
    // ui-router tracing
    // $trace.enable();
    // console.log("TR");
    // $templateRequest("/Auth/Components/Login/Login.html", true)
    //    .then((res: any) => {
    //        console.log("DONE", res);
    //    }, (reason: any) => {
    //        console.log("FAIL", reason);
    //    });

    let isLoggedIn = false;

    loginService.isLoggedInObservable().subscribe((loggedIn: boolean) => {
        isLoggedIn = loggedIn;
    });

    $transitions.onStart(
        {
            to: ((state: IMmState) =>
                (state.permission as { allowAnonymous: boolean }) &&
                !(state.permission as { allowAnonymous: boolean }).allowAnonymous) as any,
        },
        (trans: any) => {
            const state: IMmState = trans.targetState().state();
            const sitePermission: Permission = get(state.permission, "sitePermission");
            const additionalSitePermission: Permission = get(state.permission, "additionalSitePermission");
            const partnerPermission: Permission = get(state.permission, "partnerPermission");
            const additionalPartnerPermission: Permission = get(state.permission, "additionalPartnerPermission");
            const allowAnonymous: boolean = get(state.permission, "allowAnonymous");

            const specialConditionForGlobalSysAdmin =
                state.name === "partnerUserDetails" &&
                profileService.hasPermission(Permission.GlobalSysAdmin) &&
                !profileService.hasPermission(Permission.PartnerOperations);
            const allowProfilePage = isLoggedIn && state.name === "profile";
            const allowDashboard = isLoggedIn && state.name === "dashboard";

            if (
                allowAnonymous ||
                profileService.hasPermission(sitePermission) ||
                profileService.hasPermission(additionalSitePermission) ||
                profileService.hasPermission(partnerPermission) ||
                profileService.hasPermission(additionalPartnerPermission) ||
                allowProfilePage ||
                allowDashboard ||
                specialConditionForGlobalSysAdmin
            ) {
                return true;
            }
            return !isLoggedIn
                ? trans.router.stateService.target("login")
                : trans.router.stateService.target("dashboard");
        },
    );

    $transitions.onStart({}, () => {
        modalService.closeAll();
    });

    hotkeys.add({
        callback: (event: Event) => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $state.go("dashboard");
            event.preventDefault();
        },
        combo: ["g h"],
        description: "Go to home dashboard",
    });

    hotkeys.add({
        callback: (event: Event) => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $state.go("sites");
            event.preventDefault();
        },
        combo: ["g s"],
        description: "Go to sites list",
    });
}

appRun.$inject = [
    "$log",
    "$state",
    "hotkeys",
    "$http",
    "$trace",
    "$templateRequest",
    "$transitions",
    "mmLoginService",
    "mmProfileService",
    "mmModalService",
];
